import { MODULE_ID } from '@qflow/constants'

export const moduleNameFromId = (moduleTagDefinitionId: string): string => {
  if (moduleTagDefinitionId === MODULE_ID.DELIVERY) {
    return 'delivery'
  }
  return 'waste'
}

export const ALERT_MAPPER = {
  HVOFuel: {
    type: 'Fuel Detection',
    description: 'Diesel fuel detected - HVO not referenced'
  },
  LogisticsWindow: {
    type: 'Logistics Window',
    description: 'Outside permitted logistics window'
  },
  MaterialMilestones: {
    type: 'Material Milestone',
    description: ''
  },
  MaterialThreshold: {
    type: 'Material Threshold',
    description: ''
  },
  MaterialWatchlist: {
    type: 'Material Watchlist',
    description: 'Material watchlist keyword detected'
  },
  ProjectSuppliers: {
    type: 'Project Suppliers',
    description: 'Supplier not listed as a project supplier'
  },
  SupplierWatchlist: {
    type: 'Supplier Watchlist',
    description: 'Supplier on watchlist'
  }
}

export type AlertStatusType = 'Active' | 'ClientDismissed' | 'Updating'

export const ALERT_STATUS_MAPPER: { [key: string]: AlertStatusType } = {
  active: 'Active',
  clientDismissed: 'ClientDismissed',
  updating: 'Updating'
}

// Note: recordDescription = Delivery ID or Consignment Number
export type AlertType = {
  recordAlertId?: string
  recordAlertType: string
  triggeredSetting?: string
  moduleTagDefinitionId: string
  recordId: string
  lineItemId?: string | null
  recordDate: string
  recordDescription: string
  status: AlertStatusType
  isProjectLevelAlert?: boolean
}

export type ProjectAlertType = {
  projectAlertId?: string
  recordAlertType: string
  projectAlertSubruleId?: string
  triggeredSetting?: string
  moduleTagDefinitionId: string
  alertedAt: string
  status: AlertStatusType
}

// Note: InfractionAlertType is used for delivery and waste infractions
export type InfractionAlertType = {
  assignedTo?: any[]
  createdAt: string
  description: string
  destinationAddress: string
  destinationDisplayName: string
  eventKey: string
  eventType: string
  moduleName: string
  moduleTagDefinitionId: string
  projectId: string
  recordId: string
  sourceId: string
  sourceType: string
  status: string
  subDescription?: string
  subcontractor?: string
  supplier?: string
  tradeContractor?: string
  type?: string
  updatedAt: string
  wasteCarrier?: string
  isProjectLevelAlert?: boolean
}
